let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("835WZ")).then(() => parcelRequire('73LWR'));